import axios from "axios";
import { BASE_API_URL } from "../utils/api-url";

export async function getAllFreightCost(accessToken) {
  const result = await axios.get(`${BASE_API_URL}/freightCost/1000/1`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return result.data;
}

export async function getFreightCostByCompanyId(accessToken, id) {
  const result = await axios.get(
    `${BASE_API_URL}/freightCost/getByCompanyId/${id}`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  return result.data;
}

export async function getFreightCostById(accessToken, id) {
  const result = await axios.get(`${BASE_API_URL}/freightCost/${id}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return result.data;
}

export async function editFreightCostByCompany(accessToken, data) {
  const result = await axios(`${BASE_API_URL}/freightcost`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    data,
  });

  return result.data;
}
